import {DragDropContext, Draggable, Droppable} from "@hello-pangea/dnd";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
// -
import RouteIslandCard from "site-apps/distribution/route/RouteIslandCard";
import RouteWaypointCard from "site-apps/distribution/route/RouteWaypointCard";
import useCustomTranslation from "core/customTranslation";
import translations from "./translations";

const FormRouteIslandsDragDrop = ({
    waypoints,
    setWaypoints,
    dataChanged,
    setHasChanged,
    highlighted,
    setHighligthed,
    wayAssets,
    setWayAssets,
    wayRefs,
    setWayRefs,
    wasteType,
}) => {
    const {t: _CT} = useCustomTranslation(translations);

    // un clic resalta el punto en el mapa; otro clic en el mismo lo quita
    const handleHighlight = (id) => {
        setHighligthed(highlighted === id ? null : id);
    };

    const eyeButton = (_asset) => (
        <button
            type="button"
            className={`btn btn-link ${highlighted === _asset.id ? "text-primary" : "text-body-tertiary"}`}
            title={_CT("show-on-map")}
            onClick={() => handleHighlight(_asset.id)}>
            <FontAwesomeIcon icon="eye" size="lg" />
        </button>
    );

    const dragEnded = (param) => {
        const {source, destination} = param;
        let _arr = [...waypoints];
        const _item = _arr.splice(source.index, 1)[0];
        _arr.splice(destination.index, 0, _item);
        _arr = _arr.map((_way, idx) => {
            _way.order = idx + 1;
            return _way;
        });
        dataChanged.current.waypoints = [..._arr];
        setWaypoints(_arr);
        setHasChanged(true);
    };

    const handleDeleteWaypoint = (e) => {
        let idx = parseInt(e.currentTarget.value);
        let point = {...waypoints[idx]};
        if (point.status === "D" || point.status === "I") return;
        let waypoints_ = [];
        let orders = 0;
        waypoints.forEach((_point, index) => {
            if (index !== idx) {
                orders++;
                _point.order = orders;
                waypoints_.push(_point);
            }
        });
        if (point.is_island) {
            setWayAssets(wayAssets.filter((_asset) => !(_asset.is_island && _asset.id === point.island_id)));
        } else if (point.is_asset) {
            setWayAssets(wayAssets.filter((_asset) => _asset.id !== point.asset_id));
        } else if (point.mooch) {
            setWayAssets(wayAssets.filter((_asset) => _asset.id !== point.id));
        } else {
            setWayRefs(wayRefs.filter((_ref) => _ref.id !== point.waypoint_id));
        }
        dataChanged.current.waypoints = [...waypoints_];
        setWaypoints(waypoints_);
        setHasChanged(true);
    };
    const handleCopyWaypoint = (e) => {
        let idx = parseInt(e.currentTarget.value);
        let waypoint_ = {...waypoints[idx]};
        let orders = waypoints.length + 1;
        waypoint_.id = "";
        waypoint_.order = orders;
        dataChanged.current.waypoints = [...waypoints, waypoint_];
        setWaypoints([...waypoints, waypoint_]);
        if (waypoint_.is_asset || waypoint_.mooch) {
            setWayAssets([...wayAssets, waypoint_]);
        } else {
            setWayRefs([...wayRefs, waypoint_.waypoint]);
        }
        setHasChanged(true);
    };
    return (
        <DragDropContext onDragEnd={dragEnded}>
            <Droppable droppableId="assets">
                {(provided) => (
                    <ul className="dragable" {...provided.droppableProps} ref={provided.innerRef}>
                        {waypoints.map((_asset, index) => {
                            const locked = _asset.status === "D" || _asset.status === "I";
                            return _asset.is_asset || _asset.mooch ? (
                                <Draggable key={"drag-ass-" + index} draggableId={"drag-id-ass-" + index} index={index}>
                                    {(provided) => (
                                        <li
                                            className="row"
                                            key={"prov-ass-" + index}
                                            ref={provided.innerRef}
                                            {...provided.draggableProps}
                                            {...provided.dragHandleProps}>
                                            <div className="col border rounded p-2 mb-3 bg-white">
                                                <RouteIslandCard
                                                    asset={_asset}
                                                    key={"card-asset-" + index}
                                                    wasteType={wasteType}
                                                />
                                            </div>
                                            <div className="col p-0" style={{maxWidth: "29px"}}>
                                                {!locked && (
                                                    <button
                                                        type="button"
                                                        className="btn btn-link text-body-tertiary"
                                                        title="Borrar"
                                                        value={index}
                                                        onClick={handleDeleteWaypoint}>
                                                        <FontAwesomeIcon icon="trash" size="lg" />
                                                    </button>
                                                )}
                                                {eyeButton(_asset)}
                                            </div>
                                        </li>
                                    )}
                                </Draggable>
                            ) : (
                                <Draggable key={"drag-way-" + index} draggableId={"drag-id-way-" + index} index={index}>
                                    {(provided) => (
                                        <li
                                            className="row"
                                            key={"prov-way-" + index}
                                            ref={provided.innerRef}
                                            {...provided.draggableProps}
                                            {...provided.dragHandleProps}>
                                            <div className="col border rounded p-2 mb-3 bg-white">
                                                <RouteWaypointCard routeway={_asset} key={"card-way-" + index} />
                                            </div>
                                            <div className="col p-0" style={{maxWidth: "29px"}}>
                                                {!locked && (
                                                    <button
                                                        type="button"
                                                        className="btn btn-link text-body-tertiary"
                                                        title="Borrar"
                                                        value={index}
                                                        onClick={handleDeleteWaypoint}>
                                                        <FontAwesomeIcon icon="trash" size="lg" />
                                                    </button>
                                                )}
                                                <button
                                                    type="button"
                                                    className="btn btn-link text-body-tertiary"
                                                    title="Copiar"
                                                    value={index}
                                                    onClick={handleCopyWaypoint}>
                                                    <FontAwesomeIcon icon="copy" size="lg" />
                                                </button>
                                                {eyeButton(_asset)}
                                            </div>
                                        </li>
                                    )}
                                </Draggable>
                            );
                        })}
                        {provided.placeholder}
                    </ul>
                )}
            </Droppable>
        </DragDropContext>
    );
};
export default FormRouteIslandsDragDrop;
